import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ManageAssetsDetailsList = Loadable(
  lazy(() => import("./ManageAssetsDetailsList")),
);
const ManageAssetsDetailsEdit = Loadable(
  lazy(() => import("./ManageAssetsDetailsEdit")),
);

const ManageAssetsDetailsRoutes = [
  { path: "/assets/inventory", element: <ManageAssetsDetailsList /> },
  { path: "/assets/inventory/:mode/:id", element: <ManageAssetsDetailsEdit /> },
];

export default ManageAssetsDetailsRoutes;
